import { render, staticRenderFns } from "./BarCreation.vue?vue&type=template&id=e5bf5b16&scoped=true"
import script from "./BarCreation.vue?vue&type=script&lang=js"
export * from "./BarCreation.vue?vue&type=script&lang=js"
import style0 from "./BarCreation.vue?vue&type=style&index=0&id=e5bf5b16&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bf5b16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5bf5b16')) {
      api.createRecord('e5bf5b16', component.options)
    } else {
      api.reload('e5bf5b16', component.options)
    }
    module.hot.accept("./BarCreation.vue?vue&type=template&id=e5bf5b16&scoped=true", function () {
      api.rerender('e5bf5b16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inventory/BarCreation.vue"
export default component.exports